module.exports = __webpack_public_path__ + "img/ring_0_0_0_null.5d81296d.png";